package com.rajen.angrejidictionary.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.disabled
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun ContactInput(
    label: String,
    name: String,
    type: InputType<String>,
    value: String,
    onValueChange: (String) -> Unit,
    disabled: Boolean = false,
    errorMessage: String? = null
) {
    Div(attrs = { style { width(100.percent); maxWidth(500.px) } }) {
        Label(attrs = { style { fontSize(15.px); fontWeight(600); color(rgb(33, 0, 0)) } }) {
            Text(label)
        }

        Input(
            type = type,
            attrs = {
                this.name(name)
                this.value(value)
                onInput { onValueChange(it.value) }
                disabled(disabled)

                style {
                    width(100.percent)
                    backgroundColor(rgb(255, 255, 255))
                    color(rgb(33, 0, 0))
                    property("caret-color", "#210000")
                    padding(14.px)
                    border(1.px, LineStyle.Solid, if (errorMessage != null) rgb(211, 53, 62) else rgb(230, 210, 200))
                    borderRadius(14.px)
                    fontSize(16.px)
                    property("box-sizing", "border-box")
                    property("outline", "none")
                    if (disabled) property("opacity", "0.6")
                }
            }
        )

        if (errorMessage != null) {
            SpanText(
                errorMessage,
                Modifier
                    .color(Color.rgb(211, 53, 62))
                    .fontSize(12.px)
                    .margin(top = 4.px)
            )
        }
    }
}